module.exports = __webpack_public_path__ + "img/closeBlack.872b1f02.svg";